/* eslint-disable @typescript-eslint/no-unused-vars */
import { Helmet } from 'react-helmet-async';

import { _mock, _fiscal_year } from 'src/_mock';
import { _projects } from 'src/_mock/_projects';
import { _projects_name } from 'src/_mock/assets_App_Rationalization';
import { _projects_cost_list, _projects_list_Budget, _projects_list_Description, _projects_list_FTECost, _projects_list_FTEInclusive, _projects_list_ReqFTEs, _projects_list_fiscalYear } from 'src/_mock/projects_assets';

import QAWrapperComponent from './QAWrapperComponent/QAWrapperComponent';

const Projects = () => {
  const _column_data: any = {
    type: {
      Name: 'text',
      Description: 'text',
      Budget: 'currency',
      'Req. FTEs': 'text',
      'FTE Inclusive': 'boolean',
      'FTE Cost': 'currency',
      'Fiscal Years': 'text',
      // Project: 'text',
      // Year: 'singleSelect',
      Category: 'text',
      Cost: 'currency',
      Type: 'singleSelect',
    },
    options: {
      Type: ['CapEx', 'OpEx'],
      Year: [
        '2000',
        '2001',
        '2002',
        '2003',
        '2004',
        '2005',
        '2006',
        '2007',
        '2008',
        '2009',
        '2010',
        '2011',
        '2012',
        '2013',
        '2014',
        '2015',
        '2016',
        '2017',
        '2018',
        '2019',
        '2020',
        '2021',
        '2022',
        '2023',
        '2024',
        '2025',
        '2026',
        '2027',
        '2028',
        '2029',
        '2030',
        '2031',
        '2032',
        '2033',
        '2034',
        '2035',
        '2036',
        '2037',
        '2038',
        '2039',
        '2040',
        '2041',
        '2042',
        '2043',
        '2044',
        '2045',
      ],
    },
    column_questions: {
      Name: 'What is the project name?',
      Description: 'What is the description of the project?',
      Budget: 'What is the total project budget (inclusive of all years)?',
      'Req. FTEs': 'How many FTEs are required for this project?',
      'FTE Inclusive': 'Is project-related staffing/FTE cost included in the project budget?',
      'FTE Cost': 'What is the total cost of the FTEs assigned to the project?',
      'Fiscal Years': 'How many fiscal years does the project span?',
      // Project: 'text',
      // Year: 'singleSelect',
    },
  };

  const gridData: any = {
    project_list: {
      _dataGrid_0: [...Array(5)].map((_, index) => {
        const status =
          (index % 2 && 'online') || (index % 3 && 'alway') || (index % 4 && 'busy') || 'offline';

        return {
          id: _mock.id(index),
          // status,
          Name: _mock.projects.name(index),
          Description: _projects_list_Description.project_list_0[index],
          Budget: _projects_list_Budget.project_list_0[index],
          'Req. FTEs': _projects_list_ReqFTEs.project_list_0[index],
          'FTE Inclusive': _projects_list_FTEInclusive.project_list_0[index],
          'FTE Cost': _projects_list_FTECost.project_list_0[index],
          'Fiscal Years': _projects_list_fiscalYear.project_list_0[index],
        };
      }),
    },
    project_contacts: {
      _dataGrid_0: [...Array(5)].map((_, index) => {
        const status =
          (index % 2 && 'online') || (index % 3 && 'alway') || (index % 4 && 'busy') || 'offline';

        return {
          id: _mock.id(index),
          // status,
          'Project Name': _mock.projects.name(index),
          Name: _mock.projects.contact_name(index),
          Email: _mock.projects.email(index),
          Phone: _mock.projects.phone(index),
        };
      }),
    },
  };
  const modifyGridData = (Obj_key: any, gridData_obj: any) => {
    let title_length;
    console.log(Obj_key);

    switch (Obj_key) {
      case 'Impravata':
        title_length = 3;
        break;
      case 'Firewall Upgrade':
        title_length = 2;
        break;
      case 'Keytronics':
        title_length = 1;
        break;
      case 'HIM Integrations':
        title_length = 1;
        break;
      case 'Handhelds':
        title_length = 1;
        break;
      default:
        title_length = 1;
    }
    const output: any = {
      [Obj_key]: {
        titles: [...Array(title_length)].map((_, index) => `FY ${_fiscal_year[index]}`),
      },
    };
    // eslint-disable-next-line
    for (let i = 0; i < title_length; i++) {
      const dataGridKey = `_dataGrid_${i}`;
      output[Obj_key][dataGridKey] = [...Array(8)].map((_, index) => ({
        id: _mock.id(index),
        Category: _mock.app_costs.category(index),
        Cost: _projects_cost_list?.[`${Obj_key}_${i}`]?.[index],
        Type: [...Array(10)].map(() => `CapEx`)[index],
      }));
    }

    gridData_obj[Obj_key] = output[Obj_key];
  };

  _projects_name.map((item: any) => modifyGridData(item, gridData));
  const TABS = [
    { value: 'project_list', label: 'List', color: 'success' },
    {
      value: 'project_contacts',
      label: 'Contacts',
      color: 'default',
    },
    ...(_projects_name ?? []).map((item: any) => ({
      value: item,
      label: item,
    })),
  ] as const;

  console.log(gridData);

  return (
    <>
      <Helmet>
        <title> Dashboard: Projects</title>
      </Helmet>

      <QAWrapperComponent
        TABS={TABS}
        gridData={gridData}
        _column_data={_column_data}
        title="Projects"
        initialState={{
          aggregation: {
            model: {
              Cost: 'sum',
              Category: 'display_title',
            },
          },
        }}
      />
    </>
  );
};

export default Projects;
